import Backbone from 'backbone';

import GridView from '@/views/GridView';
import StringCell from '@/backgrid/StringCell';
import MultiButtonCell from '@/backgrid/MultiButtonCell';
import showModal from '@/util/showModal';
import ConfirmationModalView from '@/views/ConfirmationModalView';
import showErrorMessage from '@/util/showErrorMessage';
import showSuccessMessage from '@/util/ShowSuccessMessage';

import RemoveUserCommandAccessByExternalUserIDAndCommandID from '../../services/RemoveUserCommandAccessByExternalUserIDAndCommandID';

const CommandCustomerGridView = GridView.extend({
  className: 'command-customer-grid',

  initialize() {
    const columns = [
      {
        name: 'userId',
        label: 'User ID',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: 'fullName',
        label: 'Name',
        cell: StringCell,
        headerCell: 'custom',
        width: 20,
        editable: false,
        sortable: true
      },
      {
        name: 'email',
        label: 'Email',
        cell: StringCell,
        headerCell: 'custom',
        width: 25,
        editable: false,
        sortable: true
      },
      {
        name: 'phone',
        label: 'Phone',
        cell: StringCell,
        headerCell: 'custom',
        width: 15,
        editable: false,
        sortable: true
      },
      {
        name: '',
        label: '',
        sortable: false,
        cell: MultiButtonCell.extend({
          buttons: [
            {
              name: 'View',
              buttonClass: 'btn-primary btn-sm',
              href(model) {
                return `#customer/${model.get('id')}`;
              },
              newTab: true
            },
            {
              name: 'Remove',
              buttonClass: 'btn-danger btn-sm ladda-button',
              onClick: this.onClickDeleteCustomer.bind(this)
            }
          ]
        }),
        headerCell: 'custom',
        width: 20,
        editable: false
      }
    ];

    this.options.columns = columns;
    this.options.collection = this.model.get('collection');
    this.options.emptyText = 'No Customers Found';
  },

  onClickDeleteCustomer(e, model) {
    e.preventDefault();
    const message = `Are you sure you want to revoke command access for ${model.get('fullName')}?`;

    showModal({
      title: 'Confirm Revoking Command Access',
      view: new ConfirmationModalView({
        confirmText: 'Remove',
        model: new Backbone.Model({
          message,
          onConfirm: async () => {
            try {
              const userID = model.get('id');
              const commandID = this.model.get('commandId').commandId;
              await RemoveUserCommandAccessByExternalUserIDAndCommandID(userID, commandID);
            } catch (err) {
              this.showDeleteError();
              return err;
            }
          },
          onConfirmDone: () => {
            this.options.collection.remove(model);
            this.showDeleteSuccess();
          }
        })
      })
    });
  },

  showDeleteSuccess() {
    showSuccessMessage({
      code: 'deleteSuccess',
      title: 'Command Access Revoked',
      message: 'Command Access successfully revoked.',
      hideAfter: 5
    });
  },

  showDeleteError() {
    showErrorMessage({
      errorCode: 'deleteError',
      errorTitle: 'Command Access Revoked Error',
      errorMessage: 'An error occurred during deletion. Try again or contact an administrator if your issue persists.'
    });
  }
});

export default CommandCustomerGridView;
